import { AuthProvider } from './../../providers/auth/auth';
import { Component } from '@angular/core';
import { NavController, AlertController,LoadingController, NavParams, Loading } from 'ionic-angular';
import { LoginPage } from '../login/login';
import { HomePage } from '../home/home';
import { GlobalProvider } from '../../providers/global/global';
/**
 * Generated class for the FrontPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-front',
  templateUrl: 'front.html',
})
export class FrontPage {

  hotelname = '';
  username = '';
  isposthotel= 1;
  list_property: any[] = [];
  onhomepage = HomePage;

  constructor(public navCtrl: NavController, private auth: AuthProvider, public navParams: NavParams, private alertCtrl: AlertController, private loadingCtrl: LoadingController, private global : GlobalProvider) {
    let info = this.auth.getUserInfo();
    this.hotelname = info.hotelname;
    this.username = info.username;
    this.list_property = (info.list_property as any[]).sort((a, b) => a.hotelName.localeCompare(b.hotelName));
    
    if (info.isposthotel == '0') {
      this.isposthotel = 0;

    } else if (info.isposthotel == '2') {
      this.isposthotel = 2;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FrontPage');
  }

  logmeout() {
    this.navCtrl.setRoot(LoginPage);
  }

  openProp(event, rec) {
    this.global.use_timer_schedule= rec.use_timer_schedule;
    this.navCtrl.push(this.onhomepage, {
      icno: rec.ICNO,
      hotelname: rec.hotelName,
      isposthotel: rec.isposthotel,
      
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/front/front.ts